enum EPriceListRouteName {
  OVERVIEW = 'pricelist',
  FORM = 'pricelistForm',
}

export default EPriceListRouteName;
